module.exports = __webpack_public_path__ + "static/media/confirm-privacy-policy.babf2fc5.svg";